var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isH5)?_c('HeaderH5',{attrs:{"scrollTop":_vm.scrollTop,"current":_vm.current,"menuList":_vm.menuList}}):_c('HeaderWeb',{attrs:{"scrollTop":_vm.scrollTop,"current":_vm.current,"menuList":_vm.menuList}})
}
var staticRenderFns = []

export { render, staticRenderFns }